import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import ThemeToggle from './ThemeToggle';
import LanguageSelector from './LanguageSelector';
import { Link, useLocation } from 'react-router-dom';

import "../styles/Header.css";

const Header = ({ isAuthenticated }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const isRu =
    (i18n && typeof i18n.language === 'string' ? i18n.language : 'ru').startsWith('ru');
  const downloadLabel = isRu ? 'Скачать' : 'Download';
  const newsLabel = isRu ? 'Новости' : 'News';
  const showBackButton = location.pathname !== '/';
  return (
    <header className="header-container">
      <div className="header-buttons">
        {showBackButton && (
          <Link
            to="/"
            className="top-btn back-top-btn"
            aria-label={t('common.back')}
          >
            <i className="fas fa-arrow-left" />
          </Link>
        )}
        <Link
          to="/download"
          className="top-btn download-header-btn"
          aria-label={downloadLabel}
        >
          <i className="fas fa-download" />
          <span className="btn-text">{downloadLabel}</span>
        </Link>
        <Link
          to="/news"
          className="top-btn news-header-btn"
          aria-label={newsLabel}
        >
          <i className="fas fa-newspaper" />
          <span className="btn-text">{newsLabel}</span>
        </Link>
        <Link
          to="/profile"
          className="top-btn profile-btn"
          aria-label={t('buttons.profile')}
        >
          <i className="fas fa-user" />
          <span className="btn-text">{t('buttons.profile')}</span>
        </Link>
        
            <LanguageSelector isAuthenticated={isAuthenticated} />

        <Link
          to="/manual"
          className="top-btn instruction-top"
          target="_self"
          rel="noopener noreferrer"
          aria-label={t('buttons.manual')}
        >
          <i className="fas fa-book" />
          <span className="btn-text">{t('buttons.manual')}</span>
        </Link>

        {/* Кнопка темы вписывается в flex-ряд */}
        <ThemeToggle />
      </div>
    </header>
  );
};

export default Header;
